// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { FloatingInput } from "src/components";

import { Radio, RadioGroup, Text } from "@blueprintjs/core";

import "./styles.css";

export interface IContactInfoProps {
  senderName: any;
  emailFrom: any;
  emailReply: any;
  callerId: any;
  callerName: any;
  onRadioChanged(event: any, type: string): void;
  onInputChanged(event: any, type: string): void;
}

export const ContactInfo: React.SFC<IContactInfoProps> = props => {
  const {
    callerId,
    callerName,
    onRadioChanged,
    emailFrom,
    emailReply,
    senderName,
    onInputChanged,
  } = props;

  return (
    <div className={classNames("contact-info-container")}>
      <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          Sender Name
        </Text>
        <RadioGroup
          className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER}
          name="sender-name"
          onChange={event => onRadioChanged(event, "senderName")}
          selectedValue={senderName}
        >
          <Radio label="Jason Smith" value="senderone" />
          <Radio label="Austin Police Department" value="sendertwo" />
        </RadioGroup>
      </div>
      <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          EMAIL FROM
        </Text>
        <RadioGroup
          className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER}
          name="email-from"
          onChange={event => onRadioChanged(event, "emailFrom")}
          selectedValue={emailFrom}
        >
          <Radio label="Jason Smith" value="fromone" />
          <Radio label="Austin Police Department" value="fromtwo" />
          <Radio label="Custom" value="fromthree" />
        </RadioGroup>
      </div>
      <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          EMAIL REPLY-TO
        </Text>
        <RadioGroup
          className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER}
          name="email-to"
          onChange={event => onRadioChanged(event, "emailReply")}
          selectedValue={emailReply}
        >
          <Radio label="Jason Smith" value="replyone" />
          <Radio label="Austin Police Department" value="replytwo" />
          <Radio label="No Reply" value="replythree" />
          <Radio label="Custom" value="replyfour" />
        </RadioGroup>
      </div>
      <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER}>
        <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
          VOICE/SMS
        </Text>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER}>
          <FloatingInput
            autoCapitalize="none"
            autoCorrect="none"
            floatingType="compose"
            value={callerId.value}
            onChange={e => onInputChanged(e, "callerId")}
            placeholder="caller id"
            tabIndex={1}
          />
          <FloatingInput
            autoCapitalize="none"
            autoCorrect="none"
            floatingType="compose"
            value={callerName.value}
            onChange={e => onInputChanged(e, "callerName")}
            placeholder="caller name"
            tabIndex={1}
          />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/contact-info.tsx